import { customerFields } from '@pylot-data/core-queries/customer'

export const CUSTOMER_QUERY = /* GraphQL */ `
    {
        customer {
            ${customerFields}
        }
    }
`
